// Carrusel de infografías: avanza solo cada 3 segundos, se pausa con el
// mouse encima o al enfocar con teclado, respeta "reducir movimiento".
// Sin librerías — solo transform + un intervalo.
(function () {
  var MENOS_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)');
  var INTERVALO_MS = 3000;

  function iniciar(carrusel) {
    var pista = carrusel.querySelector('[data-tz-infografia-pista]');
    var puntos = Array.prototype.slice.call(
      carrusel.parentElement.querySelectorAll('[data-tz-infografia-punto]')
    );
    var totalSlides = pista.children.length;
    if (!pista || totalSlides < 2) return;

    var indice = 0;
    var pausado = false;
    var temporizador = null;

    function irA(nuevoIndice) {
      indice = ((nuevoIndice % totalSlides) + totalSlides) % totalSlides;
      pista.style.transform = 'translateX(-' + indice * 100 + '%)';
      puntos.forEach(function (punto, i) {
        punto.classList.toggle('is-activo', i === indice);
      });
    }

    function avanzar() {
      if (pausado) return;
      irA(indice + 1);
    }

    function comenzar() {
      detener();
      if (MENOS_MOVIMIENTO.matches) return;
      temporizador = setInterval(avanzar, INTERVALO_MS);
    }

    function detener() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    puntos.forEach(function (punto, i) {
      punto.addEventListener('click', function () {
        irA(i);
        comenzar();
      });
    });

    carrusel.addEventListener('mouseenter', function () { pausado = true; });
    carrusel.addEventListener('mouseleave', function () { pausado = false; });
    carrusel.addEventListener('focusin', function () { pausado = true; });
    carrusel.addEventListener('focusout', function () { pausado = false; });

    carrusel.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowRight') {
        evento.preventDefault();
        irA(indice + 1);
      } else if (evento.key === 'ArrowLeft') {
        evento.preventDefault();
        irA(indice - 1);
      }
    });

    comenzar();
  }

  document.querySelectorAll('[data-tz-infografia]').forEach(iniciar);
})();
